
    <h1>Document Upload</h1>
    <!-- <app-file-upload
      chooseLabel="UPLOAD DOCUMENTS"
      [data]="uploadData"
      [successMessage]="uploadSuccessMessage">
    </app-file-upload>  -->